var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"performance"}},[_c('v-alert',{attrs:{"dense":"","border":"bottom","type":"primary","icon":"mdi-information"}},[_vm._v(" PERFORMANCE ")]),_c('v-card-text',[_c('v-container',[_c('v-row')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }